import { getMerchantNotificationData } from 'pages/Merchants/MerchantsShow/MerchantsShowNotifications/utils/getMerchantNotificationData';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { useNotify, useUpdate } from 'react-admin';
import { convertReactAdminIdToHydraId } from 'utils';

type DataType = Partial<ReturnType<typeof getMerchantNotificationData>>;

export function useEditMerchantNotification(id: string, onSuccess: VoidFunction) {
  const translate = useTypedTranslate();

  const notify = useNotify();
  const [update, { isLoading }] = useUpdate();

  const mutate = (data: DataType) => {
    update(
      'merchant_notification_settings',
      {
        id: convertReactAdminIdToHydraId(id, 'merchant_notification_settings'),
        data,
      },
      {
        onError: (error: Error) => {
          notify(
            `${translate('app.common.error')}: ${error.message}` || translate('app.common.error'),
            {
              type: 'error',
            },
          );
        },
        onSuccess,
      },
    );
  };

  return { isLoading, mutate };
}
